const tools = [
  // 1. Chatbots
  {
    name: "ChatGPT",
    category: "Chatbots",
    link: "https://chat.openai.com",
    tags: ["Chatbot", "Conversation", "LLM"]
  },
  {
    name: "Claude",
    category: "Chatbots",
    link: "https://claude.ai",
    tags: ["Chatbot", "Reasoning", "Creative"]
  },
  {
    name: "Google Gemini",
    category: "Chatbots",
    link: "https://gemini.google.com",
    tags: ["Multimodal", "Search", "Assistant"]
  },
  {
    name: "Perplexity AI",
    category: "Chatbots",
    link: "https://perplexity.ai",
    tags: ["Chat Search", "Research", "Real-time"]
  },

  // 2. Automation
  {
    name: "n8n",
    category: "Automation",
    link: "https://n8n.io",
    tags: ["Automation", "No-code", "Workflow"]
  },
  {
    name: "Zapier",
    category: "Automation",
    link: "https://zapier.com",
    tags: ["Automation", "Integration"]
  },
  {
    name: "Make.com",
    category: "Automation",
    link: "https://make.com",
    tags: ["Automation", "No-code"]
  },
  {
    name: "Manus",
    category: "Automation",
    link: "https://manus.work",
    tags: ["Automation", "AI Agents"]
  },
  {
    name: "Genspark",
    category: "Automation",
    link: "https://genspark.ai",
    tags: ["Automation", "AI Agents"]
  },

  // 3. Image & Design
  {
    name: "Midjourney",
    category: "Image & Design",
    link: "https://midjourney.com",
    tags: ["Image", "Creative", "Art"]
  },
  {
    name: "Canva Magic Studio",
    category: "Image & Design",
    link: "https://canva.com",
    tags: ["Design", "Productivity", "Graphics"]
  },
  {
    name: "Leonardo AI",
    category: "Image & Design",
    link: "https://leonardo.ai",
    tags: ["Image Generation", "Creative"]
  },

  // 4. Video
  {
    name: "HeyGen",
    category: "Video",
    link: "https://heygen.com",
    tags: ["Video", "Avatars", "Multilingual"]
  },
  {
    name: "Google Veo",
    category: "Video",
    link: "https://deepmind.google/technologies/veo",
    tags: ["Video", "Editing", "Generation"]
  },
  {
    name: "OpusClip",
    category: "Video",
    link: "https://opus.pro",
    tags: ["Short Video", "Clips", "Repurposing"]
  },

  // 5. Writing
  {
    name: "Notion AI",
    category: "Writing",
    link: "https://notion.so",
    tags: ["Productivity", "Docs", "Organization"]
  },
  {
    name: "Grammarly",
    category: "Writing",
    link: "https://grammarly.com",
    tags: ["Writing", "Spelling", "Grammar"]
  },
  {
    name: "QuillBot",
    category: "Writing",
    link: "https://quillbot.com",
    tags: ["Paraphrase", "Grammar", "Writing"]
  },

  // 6. Coding
  {
    name: "GitHub Copilot",
    category: "Coding",
    link: "https://copilot.github.com",
    tags: ["Code", "Development", "Suggest"]
  },
  {
    name: "Cursor",
    category: "Coding",
    link: "https://cursor.sh",
    tags: ["AI Coding", "IDE"]
  },
  {
    name: "Replit AI",
    category: "Coding",
    link: "https://replit.com",
    tags: ["Code", "IDE", "Instant Apps"]
  },
  {
    name: "Lovable",
    category: "Coding",
    link: "https://lovable.dev",
    tags: ["No-code"]
  },

  // 7. Productivity
  {
    name: "Fathom",
    category: "Productivity",
    link: "https://fathom.video",
    tags: ["Meeting Notes", "Transcription"]
  },
  {
    name: "Otter.ai",
    category: "Productivity",
    link: "https://otter.ai",
    tags: ["Transcription", "Meetings"]
  },
  {
    name: "Calendly AI",
    category: "Productivity",
    link: "https://calendly.com",
    tags: ["Scheduling", "Meetings"]
  },

  // 8. Research
  {
    name: "NotebookLM",
    category: "Research",
    link: "https://notebooklm.google.com",
    tags: ["Research", "Summarization"]
  },

  // 9. Marketing
  {
    name: "Instantly AI",
    category: "Marketing",
    link: "https://instantly.ai",
    tags: ["Cold Email", "Automation"]
  },
  {
    name: "Clay",
    category: "Marketing",
    link: "https://clay.com",
    tags: ["Lead Enrichment", "Outreach", "Workflow Automation"]
  },
  {
    name: "Apollo.io",
    category: "Marketing",
    link: "https://apollo.io",
    tags: ["Lead Database", "Sales Automation", "Outreach"]
  },
  {
    name: "HubSpot Marketing Hub",
    category: "Marketing",
    link: "https://hubspot.com",
    tags: ["Email Automation", "CRM", "Lead Scoring"]
  },
  {
    name: "Mailchimp",
    category: "Marketing",
    link: "https://mailchimp.com",
    tags: ["Newsletter", "Email Automation", "Analytics"]
  },
  {
    name: "AdCreative",
    category: "Marketing",
    link: "https://adcreative.ai",
    tags: ["Marketing", "Copy", "Creative"]
  },
  {
    name: "Looka",
    category: "Marketing",
    link: "https://looka.com",
    tags: ["Branding", "Logo", "Design"]
  },
  {
    name: "Jasper AI",
    category: "Marketing",
    link: "https://jasper.ai",
    tags: ["Copywriting", "Content", "Marketing"]
  },

  // 10. Audio
  {
    name: "ElevenLabs",
    category: "Audio",
    link: "https://elevenlabs.io",
    tags: ["Voice Gen", "Speech", "Text-to-Speech"]
  },
  {
    name: "Murf AI",
    category: "Audio",
    link: "https://murf.ai",
    tags: ["Voice Gen", "TTS"]
  }
];

export default tools;